import reducer from './reducer';
import { actions } from './actions';
import { selectors } from './selectors';
import { types, name } from './types';
import { mapFormToRankDTO, RankFormData } from './mapper';

export default {
    name,
    reducer,
};

export { actions, selectors, types, mapFormToRankDTO };
export type { RankFormData };
